export default {
  PAGE_SETTINGS: 'page-settings',
  WEBSITE_SETTINGS: 'website-settings',
};
